<template>
    <div
        class="dropdown"
        v-click-outside="onClickedOutside(!keepOpenIfClickedInside)"
        :class="{
            'is-active': isActive,
            'is-right': !isLeft,
            'is-up': isUp,
            'is-center-on-mobile': centerOnMobile,
        }"
    >
        <div class="dropdown-trigger" @click="toggle" v-click-outside="onClickedOutside(keepOpenIfClickedInside)">
            <slot name="trigger"></slot>
        </div>
        <div class="dropdown-menu">
            <div class="dropdown-content">
                <button
                    v-if="centerOnMobile"
                    type="button"
                    class="dropdown-mobile-close is-hidden-tablet"
                    :aria-label="translate('common.close')"
                    @click="isActive = false"
                >
                    <i class="fas fa-times" aria-hidden="true"></i>
                </button>
                <slot name="content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { translate } from "./translations";

    export default {
        name: "dropdown-button",
        props: {
            isLeft: { type: Boolean, default: false },
            isUp: { type: Boolean, default: false },
            keepOpenIfClickedInside: { type: Boolean, default: false },
            centerOnMobile: { type: Boolean, default: false },
        },
        data() {
            return {
                isActive: false,
            };
        },
        mounted() {
            window.addEventListener("keydown", this.handleEscape);
        },
        beforeUnmount() {
            window.removeEventListener("keydown", this.handleEscape);
        },
        methods: {
            translate,
            toggle() {
                this.isActive = !this.isActive;
            },
            onClickedOutside(ignoreOption) {
                if (ignoreOption) {
                    return () => {};
                }
                return () => {
                    this.isActive = false;
                };
            },
            handleEscape(e) {
                if (e.key === "Escape") {
                    this.isActive = false;
                }
            },
        },
    };
</script>

<style scoped>
    .dropdown-mobile-close {
        display: none;
    }

    @media screen and (max-width: 768px) {
        .dropdown.is-center-on-mobile.is-active .dropdown-menu {
            display: block;
            position: fixed;
            top: 50%;
            left: 50%;
            right: auto;
            bottom: auto;
            transform: translate(-50%, -50%);
            z-index: 9999;
            width: calc(100vw - 2.5rem);
            max-width: 26rem;
        }

        .dropdown.is-center-on-mobile .dropdown-content {
            max-height: 80vh;
            overflow-y: auto;
        }

        .dropdown.is-center-on-mobile .dropdown-mobile-close {
            display: block;
            position: absolute;
            top: 0.25rem;
            right: 0.5rem;
            background: transparent;
            border: none;
            padding: 0.5rem;
            font-size: 1.25rem;
            line-height: 1;
            cursor: pointer;
            color: inherit;
            z-index: 1;
        }
    }
</style>
